/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface AncillaryDistributionListItem
 */
export interface AncillaryDistributionListItem {
    /**
     * 
     * @type {string}
     * @memberof AncillaryDistributionListItem
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AncillaryDistributionListItem
     */
    disabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AncillaryDistributionListItem
     */
    relevance?: number;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof AncillaryDistributionListItem
     */
    supplier?: GuidIdAndLabel;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof AncillaryDistributionListItem
     */
    ancillary?: GuidIdAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof AncillaryDistributionListItem
     */
    airline?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof AncillaryDistributionListItem
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof AncillaryDistributionListItem
     */
    distributionChannels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {boolean}
     * @memberof AncillaryDistributionListItem
     */
    allowEdit?: boolean;
}

export function AncillaryDistributionListItemFromJSON(json: any): AncillaryDistributionListItem {
    return AncillaryDistributionListItemFromJSONTyped(json, false);
}

export function AncillaryDistributionListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AncillaryDistributionListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'supplier': !exists(json, 'supplier') ? undefined : GuidIdAndLabelFromJSON(json['supplier']),
        'ancillary': !exists(json, 'ancillary') ? undefined : GuidIdAndLabelFromJSON(json['ancillary']),
        'airline': !exists(json, 'airline') ? undefined : GuidIdCodeAndLabelFromJSON(json['airline']),
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : (json['distributionChannels'] === null ? null : (json['distributionChannels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
    };
}

export function AncillaryDistributionListItemToJSON(value?: AncillaryDistributionListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
        'relevance': value.relevance,
        'supplier': GuidIdAndLabelToJSON(value.supplier),
        'ancillary': GuidIdAndLabelToJSON(value.ancillary),
        'airline': GuidIdCodeAndLabelToJSON(value.airline),
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'distributionChannels': value.distributionChannels === undefined ? undefined : (value.distributionChannels === null ? null : (value.distributionChannels as Array<any>).map(Int32IdAndLabelToJSON)),
        'allowEdit': value.allowEdit,
    };
}


